import ServiceBase from "base/baseService"
import { boolToNumber, } from "helper/formater"

export default class SerieService extends ServiceBase {

    title = "Série"
    pluralTitle = "Séries"
    url = '/cadastro/fiscal/serie'
    frontUrl = '/cadastro/fiscal/serie'
    frontUrlList = '/cadastro/fiscal/serielist'
    primaryKey = 'codigo_serie'
    ignoredsSchemaConvertions = ['usu_atua_serie']

    prepareToFront(data = {}) {

        data.ativa_serie = boolToNumber(data.ativa_serie, true)

        // Strings notNullable

        data.sigla_serie = data?.sigla_serie || ''
        data.descricao_serie = data?.descricao_serie || ''
        data.cod_modf_serie = data?.cod_modf_serie || ''

        // Numéricos sem FK

        data.prox_num_serie = data?.prox_num_serie || 0

        // Datas

        return data
    }

    prepareToSave({ data }) {

        return data

    }

}
